const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/artists/$id.finance.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindAllContractingCompaniesSuspenseQueryOptions, getFindAllContractingPersonsSuspenseQueryOptions, getFindArtistSuspenseQueryOptions } from '@api';
import { hasPermission } from '@hypeit-gmbh/hypeit-ui-core';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/artists/$id/finance')({
  beforeLoad: ({
    context: {
      permissions
    }
  }) => {
    if (!hasPermission(permissions, {
      permission: 'FINANCE',
      action: 'READ'
    })) {
      throw redirect({
        to: '/',
        replace: true,
        throw: true
      });
    }
  },
  loader: async ({
    context: {
      queryClient
    },
    params
  }) => {
    queryClient.ensureQueryData(getFindArtistSuspenseQueryOptions(params.id));
    queryClient.ensureQueryData(getFindAllContractingPersonsSuspenseQueryOptions());
    queryClient.ensureQueryData(getFindAllContractingCompaniesSuspenseQueryOptions());
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});